<!-- eslint-disable prettier/prettier -->
<template>
  <card class="card edit-card cardCustom">
    <v-btn class="close-button"
            title="Отменить"
            variant="text"
            text
            @click="close()"
    >
      <v-icon>ti-close</v-icon>
    </v-btn>
    <h4 class="title">Назначение интервью</h4>
    <div>
      <v-form @submit.prevent ref="form">
        <div class="row">
          <div class="col-12 input-text">
            <label>Название</label>
            <v-text-field
              v-model="titleInterview"
              :rules="textRules"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 input-text">
            <label>Дата</label>
            <v-text-field
              type="datetime-local" 
              v-model="dataInterview"
              :rules="textRules"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 input-text">
            <label>Участники</label>
            <multiselect 
              class="custom-ul"
              v-model="value" 
              placeholder="Введите для поиска" 
              label="title" 
              track-by="id"
              :multiple="true"
              :options="options" 
              :option-height="90" 
              :custom-label="customLabel" 
              :close-on-select="false"
              :show-labels="false"
            >
              <span slot="noResult">Нет результатов</span>
              <template slot="singleLabel" slot-scope="props">
                <span style="display:none">{{props.option.id}}</span>
                <img class="option__image select-img" :src="props.option.img">
                <span class="option__desc">
                  <span class="option__title">{{ props.option.title }}</span>
                </span>
              </template>
              <template slot="option" style="display:flex" slot-scope="props">
                
                <div class="option__desc">
                  <span style="display:none">{{props.option.id}}</span>
                  <img v-if="props.option.img != 'noFoto'" class="option__image select-img" style="margin-right: 10px; border-radius: 30px" :src="props.option.img">
                  <img v-else class="option__image select-img" style="margin-right: 10px; border-radius: 30px" src="@/assets/img/no-foto.png" alt="" />
                  <span class="option__title">{{ props.option.title }}</span>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="text-center">
          <v-btn class="btnSave primary-btn"
            v-if="successText.length == 0"
            @click="saveInterview()"
          >
            Сохранить
          </v-btn>
          <p v-else class="mt-2 success-text">{{successText}}</p>
          <p v-if="errorText.length > 0" class="mt-2 error-text">{{errorText}}</p>             
        </div>
        <div class="clearfix"></div>
      </v-form>
    </div>
  </card>
</template>
<script>
import MaskedInput from 'vue-masked-input'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import GlobalRequest from "@/plugins/globalRequest"
export default {
  components: {
    MaskedInput,
    Multiselect,
    GlobalRequest
  },
  props: {
  },
  async created() {
    let result = await GlobalRequest.request("/user/list", "GET");
    let items = result.data
    items.sort((a,b) => a.ID > b.ID ? 1 : -1)
    for(let i in items) {
      let user = items[i]
      if(user.id != localStorage.getItem('current_user') && user.id != this.$route.query.userID) {
        let obj = {}
        obj.id = user.id
        let last_name = ""
        if(user.lastName != "" && user.lastName != null)
          last_name = user.lastName
        obj.title = user.name + " " + last_name

        if(user.avatar == "" || user.avatar == undefined || user.avatar == null) {
        obj.img = "noFoto"
        }
        else {
          obj.img = user.avatar
        }
        this.options.push(obj)
      }
    }
  },
  data() {
    return {
      textRules: [
        v => !!v || 'Поле обязательно для заполнения'
      ],
      selected: null,
      value: [],
      options: [],
      titleInterview: "",
      dataInterview: this.getDate(),
      successText: "",
      errorText: ""
    };
  },
  methods: {
    customLabel ({ title }) {
      return `${title}`
    },

    async saveInterview() {
      let valid = await this.$refs.form.validate()
      if (valid) {
        let userId = localStorage.getItem('current_user') // инициатор
        let userList = []

        for(let i in this.value) {
          userList.push(this.value[i].id)
        } // участники
        
        let date = this.dataInterview.split('T')[0];
        let time = this.dataInterview.split('T')[1];

        let body = {
          title: this.titleInterview,
          date: date,
          time: time,
          owner: userId,
          interviewee: this.$route.query.userID,
          participants: userList
        }

        let result = await GlobalRequest.request("/interviews/add", "POST", body);
        if(result.success) {
          this.successText = "Интервью было успешно запланировано"
          this.errorText = ""
          this.$emit("saveInterview", "success")
        }
        else {
          this.errorText = "Произошла ошибка"
          this.successText = ""
        }
        
      }
    },

    close() {
      this.$emit("closeWindow")
    },

    getDate() {
      // 2023-10-26T18:32
      let date= new Date();
      let day = "0" + date.getDate();
      let month = "0" + (date.getMonth()+1);
      let year = date.getFullYear();
      let hours = "0" + date.getHours();
      let minutes = "0" + date.getMinutes();
      let seconds = "0" + date.getSeconds();

      return year + "-" + month.substr(-2) + "-" + day.substr(-2) + "T" + hours.substr(-2) + ':' + minutes.substr(-2);
    },
  },
};
</script>
<style>
.cardCustom {
  font-family: 'Montserrat', sans-serif;
}
</style>
